// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"f93f12ed","129":"41967afb","245":"18fb7e64","453":"6162beab","935":"1089dca4"}[chunkId] + ".chunk.js";
};